'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _renderProp = require('../utils/propTypes/renderProp');

var RenderProp = _interopRequireWildcard(_renderProp);

var _createLazyPropType = require('../utils/propTypes/createLazyPropType');

var _createLazyPropType2 = _interopRequireDefault(_createLazyPropType);

var _H = require('../elements/headings/H2');

var _H2 = _interopRequireDefault(_H);

var _lazyEval = require('../utils/lazyEval');

var _lazyEval2 = _interopRequireDefault(_lazyEval);

var _UIIllustration = require('../image/UIIllustration');

var _UIIllustration2 = _interopRequireDefault(_UIIllustration);

var _UISection = require('../section/UISection');

var _UISection2 = _interopRequireDefault(_UISection);

var _illustrationName = require('../utils/propTypes/illustrationName');

var _component = require('../utils/propTypes/component');

var _component2 = _interopRequireDefault(_component);

var _Style = require('../core/Style');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var MessageOuter = (0, _styledComponents2.default)(_UISection2.default).withConfig({
  displayName: 'UIResultsMessage__MessageOuter'
})(['text-align:center;']);

var MessageBody = _styledComponents2.default.div.withConfig({
  displayName: 'UIResultsMessage__MessageBody'
})(['']);

var MessageImage = (0, _styledComponents2.default)(_UIIllustration2.default).withConfig({
  displayName: 'UIResultsMessage__MessageImage'
})(['margin-bottom:', ';'], (0, _Style.remCalc)(40));

var defaultIllustrationProps = { width: 175 };

var renderTitle = function renderTitle(title) {
  if (!title) return null;
  if (_react2.default.isValidElement(title)) return title;

  return _react2.default.createElement(
    _H2.default,
    null,
    (0, _lazyEval2.default)(title)
  );
};

var renderImage = function renderImage(illustration, illustrationProps, Image) {
  if (!illustration && !Image) return null;

  return _react2.default.createElement(Image, _extends({
    name: illustration
  }, defaultIllustrationProps, illustrationProps));
};

exports.default = _react2.default.createClass({
  displayName: 'UIResultsMessage',

  propTypes: {
    Body: _component2.default,
    children: _react.PropTypes.node,
    illustration: (0, _illustrationName.getIllustrationNamePropType)(),
    illustrationProps: _react.PropTypes.object,
    Image: RenderProp.getPropType(_UIIllustration2.default),
    title: (0, _createLazyPropType2.default)(_react.PropTypes.node)
  },

  getDefaultProps: function getDefaultProps() {
    return {
      Body: MessageBody,
      Image: MessageImage,
      illustrationProps: defaultIllustrationProps
    };
  },
  render: function render() {
    var _props = this.props,
        Body = _props.Body,
        children = _props.children,
        className = _props.className,
        illustration = _props.illustration,
        illustrationProps = _props.illustrationProps,
        Image = _props.Image,
        title = _props.title,
        rest = _objectWithoutProperties(_props, ['Body', 'children', 'className', 'illustration', 'illustrationProps', 'Image', 'title']);

    return _react2.default.createElement(
      MessageOuter,
      _extends({}, rest, { className: className, role: 'alert', use: 'island' }),
      renderImage(illustration, illustrationProps, Image),
      renderTitle(title),
      _react2.default.createElement(
        Body,
        null,
        children
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/results/UIResultsMessage.js
// module id = 501
// module chunks = 3 4 5